module.exports = __webpack_public_path__ + "static/media/8990.671d4c63.jpg";